import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { AssistantTelemetryPage } from '@/components/admin/assistant-telemetry';

// Platform-admin only and subsidiary-wide; the API is the durable gate (403 for anyone else).
export const Route = createFileRoute('/admin/assistant-telemetry/')({
  beforeLoad: ({ context }) => {
    requireRole(context, ['admin'], '/admin/assistant-telemetry');
  },
  component: AssistantTelemetryPage,
});
